module.exports = __webpack_public_path__ + "media/images/icons/payment_methods/Paypal-ff0b91714ac56142b677fc0ca737fc56.svg";